// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"607":"facc04ee","668":"facc04ee"}[chunkId] + ".chunk.css";
};